// extracted by mini-css-extract-plugin
export default {"listHeader":"IncidentList_listHeader__mu15T","list":"IncidentList_list__7ipMx"};